import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://mcarefisio.it";

function Seo() {
  const location = useLocation();

  const canonicalUrl = `${SITE_URL}${location.pathname.endsWith("/")
    ? location.pathname
    : `${location.pathname}/`
  }`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

export default Seo;